class TableCollapser {
    constructor() {
        this.tableList = Array.from(document.querySelectorAll('.table.js-table-collapser'));

        this.initialize();
    }
    initialize() {
        this.tableList.map(table => {
            const toggleButtons = Array.from(table.querySelectorAll('[data-toggle-collapse]'));
            const allButtonRows = this.getAllButtonContainers(toggleButtons);

            toggleButtons.map(button => {
                const name = button.dataset.toggleCollapse;
                const collapseRow = table.querySelector(`[data-collapse="${name}"]`);

                button.addEventListener('click', () => this.bindToggle(table, button, collapseRow, allButtonRows));
            });
        });
    }
    bindToggle(table, button, collapseRow, allButtonRows) {
        const buttonRow = button.parentNode.parentNode;

        if (!!buttonRow) {
            if (collapseRow.classList.contains('hidden')) {
                this.openRow(table, allButtonRows, buttonRow, collapseRow);
            } else {
                this.closeRow(buttonRow, collapseRow);
            }
        }
    }
    openRow(table, allButtonRows, buttonRow, collapseRow) {
        const allCollapseRows = Array.from(table.querySelectorAll('[data-collapse]'));

        allButtonRows.map(item => item.classList.remove('is-open'));
        allCollapseRows.map(item => item.classList.add('hidden'));

        buttonRow.classList.add('is-open');
        collapseRow.classList.remove('hidden');
    }
    closeRow(buttonRow, collapseRow) {
        buttonRow.classList.remove('is-open');
        collapseRow.classList.add('hidden');
    }
    getAllButtonContainers(buttons) {
        const rows = [];

        buttons.map(button => rows.push(button.parentNode.parentNode));

        return rows;
    }
}

new TableCollapser();
